import React, { useEffect, useState } from 'react'
import { GetById_ByFoodsAndParking_Reserve_Api } from '../../API/ReserveApi';
import { Button, Col, Row } from 'antd';
import { CloseOutlined, DeleteOutlined, DoubleLeftOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ReserveInfoComponent } from '../Reserve/ReserveInfoComponent';
import { ReservePlaceAndTimeComponent } from '../Reserve/ReservePlaceAndTimeComponent';
import { FactorComponent } from './FactorComponent';
import { PaymentComponent_FoodAndParking } from './PaymentComponent_FoodAndParking';

export const AReserveFoodsAndParking_Step2_Component = ({
    setLoading,
    showMessage,
    reserveId,
    onBackClick,
    onPayCompleted,
}) => {
    // ======================================================================
    const [reserve, setReserve] = useState();
    // ======================================================================
    useEffect(() => {
        loadReserve();
    }, []);
    // ======================================================================
    const loadReserve = async () => {
        setLoading(true);
        try {
            const data = await GetById_ByFoodsAndParking_Reserve_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setReserve(data.messageData.data);
            }

            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            {reserve ?
                <>
                    <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
                        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                            <Button
                                className='step-prev-btn btn-light'

                                onClick={() => { onBackClick() }}
                            >
                                <DoubleRightOutlined />
                                <span className='step-prev-btn-title'>
                                    بازگشت
                                </span>
                            </Button>

                        </Col>
                        <Col xs={10} sm={10} md={10} lg={16} xl={16}>
                            <h2>
                                رزرو {reserve.period.enableFoodReserve ? "غذا" : <></>}

                                {reserve.period.enableParkingReserve ? "/پارکینگ" : <></>}
                            </h2>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "left" }} >
                            {/* <Button
                                        className={'step-next-btn btn-primary'}
                                        onClick={() => { setView('payment') }}
                                    >
                                        <span className='step-next-btn-title'>
                                            تایید و ادامه
                                        </span>
                                        <DoubleLeftOutlined />
                                    </Button> */}
                        </Col>
                    </Row>

                    <div className="no-print">
                        <ReserveInfoComponent adminMode={false} setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                        <ReservePlaceAndTimeComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                    </div>
                    <FactorComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} />

                    <PaymentComponent_FoodAndParking
                        reserve={reserve}
                        period={reserve.period}
                        setLoading={setLoading}
                        showMessage={showMessage}
                        onPayCompleted={onPayCompleted}
                    />
                </> : <></>}
        </>
    )

}

